import React from 'react';

const PusherContext = React.createContext();

export default PusherContext;
